// src/components/SupportVideos.js
import React, { useEffect, useState } from "react";
import { fetchSupportVideos } from "../helpers/contentfulHelper";
import "../styles/SupportVideos.css";
import { useTranslation } from "../context/TranslationContext";
import ReactMarkdown from "react-markdown";

const SupportVideos = () => {
  const [videos, setVideos] = useState([]);
  const { t, language } = useTranslation();

  useEffect(() => {
    const loadVideos = async () => {
      const items = await fetchSupportVideos();
      setVideos(items);
    };
    loadVideos();
  }, []);

  return (
    <>
      <div className="support-videos-container">
        <div className="heading mb-20">
          {t("support_videos_heading") || "Support Videos"}
        </div>

        {videos.length === 0 ? (
          <p>{t("support_videos_none")}</p>
        ) : (
          <div className="video-grid">
            {videos.map(({ sys, fields }) => {
              const title =
                language === "pt"
                  ? fields.titlePt || fields.title
                  : fields.title;
              const description =
                language === "pt"
                  ? fields.descriptionPt || fields.description
                  : fields.description;

              return (
                <div key={sys.id} className="video-card">
                  <h3 className="video-title">{title}</h3>
                  <div className="video-date">
                    {sys.createdAt &&
                      new Date(sys.createdAt).toLocaleDateString(language, {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                  </div>
                  <div className="video-frame">
                    <iframe
                      src={fields.youtubeUrl}
                      title={title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                  <div className="video-description mt-20">
                    <ReactMarkdown>{description}</ReactMarkdown>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default SupportVideos;
